import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from '@/mixins/packageTableMixins';
import customDetails from './components/customDetails.vue';
import uploadCom from "./components/uploadCom";
import addCom from './components/addCom';
import config from '@/config/index';
import { dict_list, set_default as _set_default, dict_add, dict_update, dict_del, daoru as _daoru, daochu, get_downloadtoken } from '@/api/jingxiaoshang';
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      product_type_code: "",
      xieyi_name: "",
      country_codeData: [{
        "value": "xciot-prod-cnsz",
        "name": "中国区"
      }, {
        "value": "xciot-prod-hk",
        "name": "香港区"
      }, {
        "value": "xciot-prod-eu",
        "name": "欧洲区"
      }, {
        "value": "xciot-prod-us2",
        "name": "美国区"
      }],
      country_code2Data: [{
        "value": "86",
        "name": "中国"
      }],
      form_filter: {
        protocol_name: "",
        model_code: ""
      },
      //共用的查询与重置
      topButtonList: [{
        name: this.$t("query"),
        type: 'primary',
        method: this.search
      }, {
        name: this.$t("reset"),
        type: 'error',
        method: this.reset
      }],
      //共用的右侧添加按钮
      topButtonList1: [{
        name: this.$t('add'),
        icon: 'ios-add',
        type: 'primary',
        method: this.add
      }, {
        name: this.$t('import'),
        icon: 'ios-cloud-upload',
        type: 'primary',
        method: this.daoru
      }, {
        name: this.$t('export'),
        icon: 'ios-cloud-download',
        type: 'primary',
        method: this.daochu
      }],
      reqBase: {
        page: 1,
        page_size: 15
      },
      status: true,
      //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [{
        name: this.$t('edit'),
        type: 'primary',
        icon: '',
        method: this.edit
      }, {
        name: this.$t('delete'),
        type: 'primary',
        icon: '',
        method: this.del
      }],
      // operationButtonList1:[
      //   {
      //     name:this.$t('operationModule.submitReview'),
      //     type:'primary',
      //     icon:'',
      //     method:this.submitReview
      //   },
      // ],
      columnsheader: [// {
      //   align: 'center',
      //   title: '产品型号',
      //   minWidth:120,
      //   key: 'model_code',
      // },
      {
        align: 'center',
        title: this.$t('dictmenu.protocoltype'),
        minWidth: 120,
        key: 'protocol_type_name'
      }, {
        align: 'center',
        title: this.$t('dictmenu.protocolnumber'),
        minWidth: 120,
        key: 'protocol_number'
      }, {
        align: 'center',
        title: this.$t('dictmenu.protocolname'),
        minWidth: 120,
        key: 'protocol_name'
      }, {
        align: 'center',
        title: this.$t('dictmenu.invertertype'),
        minWidth: 120,
        key: 'inverter_type_name'
      }, {
        align: 'center',
        title: this.$t('dictmenu.creationtime'),
        minWidth: 120,
        key: 'addtime'
      }, {
        align: 'center',
        title: this.$t('operation'),
        minWidth: 150,
        key: 'Operating',
        render: function render(h, _ref) {
          var row = _ref.row;
          var arr = []; //this.operationButtonList = [];

          var list = _this2.operationButtonList[0]; //编辑

          arr.push(h('Button', {
            style: {
              marginLeft: '5px',
              marginBottom: '3px'
            },
            props: {
              type: list.type,
              size: list.size ? list.size : 'small'
            },
            on: {
              click: function click() {
                _this2.edit(row);
              }
            }
          }, list.name)); //删除

          list = _this2.operationButtonList[1];
          arr.push(h('Button', {
            style: {
              marginLeft: '5px',
              marginBottom: '3px'
            },
            props: {
              type: list.type,
              size: list.size ? list.size : 'small'
            },
            on: {
              click: function click() {
                _this2.del(row);
              }
            }
          }, list.name)); //  //查看
          //  list=this.operationButtonList[2];
          // arr.push(h('Button', {
          //         style: {marginLeft: '5px',marginBottom:'3px'},
          //         props: {
          //           type: list.type,
          //           size: list.size ? list.size : 'small'
          //         },
          //         on: {
          //           click: () => {
          //             this.details(row)
          //           }
          //         } 
          // }, list.name));

          return h('div', {
            style: {
              padding: '5px'
            }
          }, arr); // return h('div',arr)
        }
      }]
    };
  },
  props: {
    reducehe: {},
    code: {}
  },
  components: {
    customDetails: customDetails
  },
  computed: {},
  methods: {
    /**
     * 导入
     */
    daoru: function daoru() {
      var _this3 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h('div', [h('h3', _this3.$t('import')), h(uploadCom, {
            ref: 'uploadCom',
            props: {
              edit: false,
              _vm: vm
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.uploadCom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              var formData = new FormData();
              formData.append('filename', formModel.filename);
              formData.append('xieyi_code', vm.$route.query.xieyi_code);
              formData.append('product_code', vm.$route.query.product_code);

              _daoru(formData).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg, 5);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    daochu: function daochu() {
      var vm = this;
      var config = {
        title: this.$t('export'),
        loading: true,
        content: this.$t('dictmenu.sureexport'),
        onOk: function onOk() {
          var _this = this; // vm.$store.dispatch("user/handleget_downloadtoken", { type: "did" })
          //   .then((res) => {


          get_downloadtoken().then(function (res) {
            // console.log(res.result) 
            //     return
            _this.buttonLoading = false;

            if (res.result === 0) {
              var downloadtoken = res.body.downloadtoken;
              var params = "?type=1&downloadtoken=" + downloadtoken + "&xieyi_code=" + vm.$route.query.xieyi_code + "&product_code=" + vm.$route.query.product_code;
              window.open("http://pcphp.test.xcthings.com/index.php/admin/dict/daochu" + params);
              vm.$Modal.remove();
            } else {
              vm.$Message.error(res.errorMsg);
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
        * 删除
        */
    del: function del(row) {
      var vm = this;
      this.$Modal.confirm({
        title: this.$t('delete'),
        content: this.$t('dictmenu.suredelete') + row.protocol_type_name + row.protocol_number + this.$t('dictmenu.ma'),
        loading: true,
        onOk: function onOk() {
          var _this = this;

          dict_del({
            dict_code: row.dict_code
          }).then(function (res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg = res.errorMsg;
              vm.$Message.success(_msg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    },
    details: function details(row) {
      var _this4 = this;

      var vm = this;
      var config = {
        okText: "关闭",
        loading: true,
        width: 600,
        render: function render(h) {
          return h('div', [h('h3', _this4.$t('viewdetails')), h(addCom, {
            ref: 'addCom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              hasDetails: true,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          this.$Modal.remove();
        }
      };
      this.$Modal.success(config);
    },
    add: function add() {
      var _this5 = this;

      var vm = this;
      var is_huise = false;
      console.log("asdf", vm.product_type_code);

      if (vm.product_type_code == "222" || vm.product_type_code == "333") {
        is_huise = true; //  alert(11)
      }

      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, _this5.$t('dictmenu.addinverterdict')), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addCom, {
            ref: 'addCom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: '0',
              parent_name: '无',
              is_huise: is_huise,
              product_type_code: vm.product_type_code
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            console.log("add打印", vm.$route.query.xieyi_code); //   return

            if (res) {
              dict_add(_objectSpread({}, obj.formModel, {
                xieyi_code: vm.$route.query.xieyi_code,
                product_code: vm.$route.query.product_code
              })).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg2 = res.errorMsg;
                  vm.$Message.success(_msg2);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    edit: function edit(row) {
      var _this6 = this;

      console.log('a', row);
      var vm = this;
      var is_huise = false;

      if (vm.product_type_code == "222" || vm.product_type_code == "333") {
        is_huise = true;
      }

      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, _this6.$t('dictmenu.editiverterdict')), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addCom, {
            ref: 'addCom',
            props: {
              edit: true,
              $store: vm.$store,
              _vm: vm,
              setData: row,
              is_huise: is_huise,
              product_type_code: vm.product_type_code
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            if (res) {
              //let { area_name, desc, area_code } = obj.formModel
              dict_update(_objectSpread({}, obj.formModel, {
                'xieyi_code': row.xieyi_code,
                'product_code': vm.$route.query.product_code
              })).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg3 = res.errorMsg;
                  vm.$Message.success(_msg3);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    set_default: function set_default(row) {
      // console.log(row)
      var vm = this;
      this.$Modal.confirm({
        title: '设为默认',
        content: '您确定要设置' + row.protocol_name + '为默认吗？',
        loading: true,
        onOk: function onOk() {
          var _this = this;

          _set_default({
            dict_code: row.dict_code
          }).then(function (res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg4 = res.errorMsg;
              vm.$Message.success(_msg4);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    },
    init: function init() {
      var _this7 = this;

      // this.get_type();
      this.tableLoading = true;
      dict_list(_objectSpread({}, this.reqBase, {
        "xieyi_code": this.$route.query.xieyi_code,
        'product_code': this.$route.query.product_code
      })).then(function (res) {
        _this7.tableLoading = false;
        _this7.tableDataList = [];

        if (res.result === 0) {
          _this7.xieyi_name = res.body.xieyi.xieyi_name;
          _this7.product_type_code = res.body.xieyi.product_type_code;
          _this7.tableDataList = res.body.list || [];
          _this7.getPageTotal = res.body.total;
        } else {
          _this7.tableDataList = [];
          _this7.getPageTotal = 0;

          _this7.$Message.error(res.errorMsg);
        }
      });
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        protocol_name: null,
        model_code: null
      };
      this.search();
    }
  },
  mounted: function mounted() {
    if (this.code) {
      this.$set(this.reqBase, 'project_code', this.code);
    }

    if (this.reducehe) {
      this.reduceheight = this.reducehe;
    } else {
      this.init();
    }
  },
  created: function created() {// this.getPageSizeToStorage();
  }
};